var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0.75C4.6575 0.75 6 2.06625 6 3.69C6 2.06625 7.3425 0.75 9 0.75C10.6575 0.75 12 2.06625 12 3.69C12 6.13725 9.5745 7.0005 6.294 10.896C6.25788 10.9388 6.21286 10.9732 6.16208 10.9968C6.11131 11.0203 6.05599 11.0326 6 11.0326C5.94401 11.0326 5.88869 11.0203 5.83792 10.9968C5.78714 10.9732 5.74212 10.9388 5.706 10.896C2.4255 7.0005 0 6.13725 0 3.69C0 2.06625 1.3425 0.75 3 0.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_18925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/white-heart.34e66f06ed22e01c2e2f79f7371d740f.svg";
export { ForwardRef as ReactComponent };